import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from "react";
import { Box, Icon, Flex, FormControl, FormLabel, Spacer, useBoolean } from "@chakra-ui/react";
import moment from "moment";
import DatePicker from "@inspire/ui/chakra/forms/DatePicker";
import { CheckIcon } from "@inspire/ui/icons";
import Spinner from "@inspire/ui/chakra/Spinner";
export var StandaloneDate = function(_param) {
    var initialDate = _param.initialDate, onChange = _param.onChange, onError = _param.onError, label = _param.label, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, datePickerProps = _param.datePickerProps, formControlProps = _object_without_properties(_param, [
        "initialDate",
        "onChange",
        "onError",
        "label",
        "isRequired",
        "datePickerProps"
    ]);
    var ref = useState(null), randomString = ref[0], setRandomString = ref[1];
    var ref1 = useState(initialDate), selectedDate = ref1[0], setSelectedDate = ref1[1];
    var ref2 = _sliced_to_array(useBoolean(false), 2), isConfirmed = ref2[0], ref3 = ref2[1], enableIsConfirmed = ref3.on, disableIsConfirmed = ref3.off;
    var ref4 = _sliced_to_array(useBoolean(false), 2), isSubmitting = ref4[0], ref5 = ref4[1], enableIsSubmitting = ref5.on, disableIsSubmitting = ref5.off;
    var confirmedTimeoutRef = useRef(null);
    useEffect(function() {
        setRandomString((Math.random() + 1).toString(36).substring(7));
    }, []);
    var handleChange = function() {
        var _ref = _async_to_generator(function(val) {
            var simpleDate, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!val) {
                            setSelectedDate(initialDate);
                            return [
                                2
                            ];
                        }
                        simpleDate = moment(val).utcOffset(0, true).startOf("day").toDate();
                        enableIsSubmitting();
                        clearTimeout(confirmedTimeoutRef.current);
                        setSelectedDate(simpleDate);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onChange(simpleDate)
                        ];
                    case 2:
                        _state.sent();
                        enableIsConfirmed();
                        confirmedTimeoutRef.current = setTimeout(disableIsConfirmed, 2000);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        onError && onError(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        disableIsSubmitting();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange(val) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        return function() {
            return clearTimeout(confirmedTimeoutRef.current);
        };
    }, []);
    useEffect(function() {
        return setSelectedDate(initialDate);
    }, [
        initialDate
    ]);
    return /*#__PURE__*/ _jsxs(FormControl, _object_spread_props(_object_spread({
        isRequired: isRequired
    }, formControlProps), {
        children: [
            label && /*#__PURE__*/ _jsx(FormLabel, {
                htmlFor: randomString,
                children: label
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                align: "center",
                maxW: "155px",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        w: "full",
                        children: /*#__PURE__*/ _jsx(DatePicker, _object_spread({
                            id: randomString,
                            placeholderText: "jj/mm/aaaa",
                            dateFormat: "dd/MM/yyyy",
                            selectedDate: selectedDate,
                            onChange: handleChange,
                            utcOffset: moment().utcOffset(),
                            // @ts-ignore
                            autoComplete: "off"
                        }, datePickerProps))
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {}),
                    /*#__PURE__*/ _jsx(Box, {
                        ml: 3,
                        w: 8,
                        h: 7,
                        children: isSubmitting ? /*#__PURE__*/ _jsx(Spinner, {}) : isConfirmed ? /*#__PURE__*/ _jsx(Icon, {
                            as: CheckIcon,
                            boxSize: 7,
                            color: "green.500"
                        }) : null
                    })
                ]
            })
        ]
    }));
};
export default StandaloneDate;
